import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LandingLayout from "./LandingLayout";

const SubscriberFaqPage = () => {
  const [activeTab, setActiveTab] = useState("why-subscribe");

  useEffect(() => {
    const handleScroll = () => {
      const cards = document.querySelectorAll(".faq-card");
      const scrollPos = window.scrollY + 200;

      cards.forEach((card) => {
        const id = card.getAttribute("id");
        if (id) {
          const top = card.offsetTop;
          const height = card.offsetHeight;
          if (scrollPos >= top && scrollPos < top + height) {
            setActiveTab(id);
          }
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <LandingLayout title="Subscriber FAQ | Rebel">
      <section className="page-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="breadcrumbs">
            <Link to="/">Home</Link>
            <span>›</span>
            <span>Subscriber FAQ</span>
          </div>

          <p className="page-label">FAQ</p>
          <h1>Subscriber Questions</h1>
          <p className="updated">◷ Updated At: 8 months ago</p>
          <p className="hero-description">
            Find answers about subscriptions, billing, renewals, refunds, chargebacks, and supporting your favourite creators on Rebel.
          </p>
        </div>
        <div className="hero-art d-none">
          <img src="/assets/hero-phones.png" alt="Rebel app shown on two mobile phones" />
        </div>
      </section>

      <div className="faq-layout">
        <aside className="faq-sidebar">
          <div className="sidebar-card">
            <h2>In This Guide</h2>
            <nav className="sidebar-nav">
              <a className={activeTab === "why-subscribe" ? "active" : ""} href="#why-subscribe">Why Subscribe</a>
              <a className={activeTab === "finding-profile" ? "active" : ""} href="#finding-profile">Finding a Profile</a>
              <a className={activeTab === "how-to-subscribe" ? "active" : ""} href="#how-to-subscribe">How to Subscribe</a>
              <a className={activeTab === "unable-to-subscribe" ? "active" : ""} href="#unable-to-subscribe">Unable to Subscribe</a>
              <a className={activeTab === "cancel-subscription" ? "active" : ""} href="#cancel-subscription">Cancel Subscription</a>
              <a className={activeTab === "auto-renewal" ? "active" : ""} href="#auto-renewal">Auto Renewal</a>
              <a className={activeTab === "card-description" ? "active" : ""} href="#card-description">Credit Card Description</a>
              <a className={activeTab === "transaction-charges" ? "active" : ""} href="#transaction-charges">Transaction Charges</a>
              <a className={activeTab === "refunds" ? "active" : ""} href="#refunds">Refunds</a>
              <a className={activeTab === "chargebacks" ? "active" : ""} href="#chargebacks">Disputes / Chargebacks</a>
              <a className={activeTab === "funded-incorrectly" ? "active" : ""} href="#funded-incorrectly">Funded Incorrect Amount</a>
            </nav>
          

          <div className="support-card">
            <h3>Still have questions?</h3>
            <p>Our support team is here to help.</p>
            <a href="mailto:support@rebeltv.me" className="support-button">Contact Support</a>
            </div>
          </div>
        </aside>

        <section className="faq-content">
          <article className="faq-card" id="why-subscribe">
            <div className="faq-icon">
              <img src="/assets/icons/why-subscribe.svg" alt="" />
            </div>
            <div className="faq-copy">
              <h2>Why Subscribe</h2>
              <p>
                Subscribing to a Creator gives you exclusive access to private content being posted by that Creator and gives you access to be able to communicate with them directly via the direct messages interface.
              </p>
            </div>
          </article>

          <article className="faq-card" id="finding-profile">
            <div className="faq-icon">
              <img src="/assets/icons/search.svg" alt="" />
            </div>
            <div className="faq-copy">
              <h2>Finding a Profile</h2>
              <ol>
                <li>On your home page start typing the name of the content creator in the Search Bar.</li>
                <li>If you know the exact username of the person you are looking for, you can find them by going to www.rebeltv.me/&lt;insertusernamehere&gt;</li>
              </ol>
            </div>
          </article>

          <article className="faq-card" id="how-to-subscribe">
            <div className="faq-icon">
              <img src="/assets/icons/subscribe.svg" alt="" />
            </div>
            <div className="faq-copy">
              <h2>How to Subscribe</h2>
              <ol>
                <li>Add a valid credit card to your account.</li>
                <li>Click “Subscribe” on the profile you wish to subscribe to.</li>
                <li>Clicking “Subscribe” will charge your credit card on file with REBEL.</li>
                <li>Clicking “Subscribe” on a free account will not charge your credit card.</li>
                <li>A successful “Subscribe” will instantly unlock the content in that profile including all previous posts and all future posts during the subscription period.</li>
                <li>Subscription periods are one calendar month from the date of purchase.</li>
              </ol>
            </div>
          </article>

          <article className="faq-card" id="unable-to-subscribe">
            <div className="faq-icon">
              <img src="/assets/icons/warning.svg" alt="" />
            </div>
            <div className="faq-copy">
              <h2>I Am Unable to Subscribe to an Account</h2>
              <ol>
                <li>Use an up-to-date web browser.</li>
                <li>Link a valid credit card in your account.</li>
              </ol>
            </div>
          </article>

          <article className="faq-card" id="cancel-subscription">
            <div className="faq-icon">
              <img src="/assets/icons/cancel.svg" alt="" />
            </div>
            <div className="faq-copy">
              <h2>Cancel Subscription</h2>
              <ol>
                <li>Subscriptions are non-refundable.</li>
                <li>Visit your “Following” page to see all of your active and inactive subscriptions. You can unsubscribe, but unsubscribing does not refund your purchase.</li>
                <li>You will be able to Follow that profile again during the Subscription period without being re-billed.</li>
              </ol>
            </div>
          </article>

          <article className="faq-card" id="auto-renewal">
            <div className="faq-icon">
              <img src="/assets/icons/renew.svg" alt="" />
            </div>
            <div className="faq-copy">
              <h2>Auto Renewal</h2>
              <p>Subscriptions are set to auto-renew by default.</p>
              <p>Subscriptions may not auto-renew if:</p>
              <ol>
                <li>Your credit card was declined.</li>
                <li>The subscription price has increased.</li>
                <li>You have unsubscribed.</li>
              </ol>
            </div>
          </article>

          <article className="faq-card" id="card-description">
            <div className="faq-icon">
              <img src="/assets/icons/card.svg" alt="" />
            </div>
            <div className="faq-copy">
              <h2>How Does a REBEL Charge Show on My Credit Card?</h2>
              <p>The credit card descriptors will say “REBELTV” or “REBEL” or some variation, but will always have “REBEL” in the descriptor.</p>
            </div>
          </article>

          <article className="faq-card" id="transaction-charges">
            <div className="faq-icon">
              <img src="/assets/icons/money.svg" alt="" />
            </div>
            <div className="faq-copy">
              <h2>Transaction Charges</h2>
              <p>Our prices appear in USD/BSD. The currency conversion is done at the bank level and not by rebeltv.me.</p>
              <p>All credit card charges are in USD/BSD. We use a secure and encrypted third-party payment processor to complete transactions.</p>
              <p>In some cases you may need to confirm your purchase with an additional temporary verification code or SMS code during the billing process.</p>
            </div>
          </article>

          <article className="faq-card" id="refunds">
            <div className="faq-icon">
              <img src="/assets/icons/refund.svg" alt="" />
            </div>
            <div className="faq-copy">
              <h2>Refunds</h2>
              <p>Purchases are final and non-refundable. You may unsubscribe for any reason, at any time, to ensure that you will not be billed for that subscription again.</p>
            </div>
          </article>

          <article className="faq-card" id="chargebacks">
            <div className="faq-icon">
              <img src="/assets/icons/chargeback.svg" alt="" />
            </div>
            <div className="faq-copy">
              <h2>Credit Card Disputes / Chargebacks</h2>
              <p>If a User seeks a chargeback or dispute from their credit card company, the User’s access to REBEL may be discontinued or limited. If you believe your account has been limited in error, please contact support.</p>
              <p>Any amounts that Users seek to refund or chargeback will be reported to the Creator and will be removed from the Creator’s income.</p>
            </div>
          </article>

          <article className="faq-card" id="funded-incorrectly">
            <div className="faq-icon">
              <img src="/assets/icons/wallet.svg" alt="" />
            </div>
            <div className="faq-copy">
              <h2>Funded Incorrect Amount</h2>
              <p>We are unable to issue refunds for:</p>
              <ul>
                <li>Funded Amounts</li>
              </ul>
              <p>A Subscriber may try to contact the Creator directly with regard to this issue.</p>
            </div>
          </article>
        </section>
      </div>
    </LandingLayout>
  );
};

export default SubscriberFaqPage;
